import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { FaUsers, FaGamepad, FaStore, FaChartBar, FaUserShield, FaRobot, FaBell, FaChartLine, FaLightbulb, FaSignOutAlt, FaCog, FaRunning, FaShieldAlt, FaBoxOpen, FaEye, FaShareAlt, FaGift, FaNewspaper, FaApple, FaAndroid, FaUserCheck, FaUserSlash, FaTrashAlt } from "react-icons/fa"

//Components
import TokenService from "../../services/token_services"
import AdminService from "../../services/admin_services"

class AdminHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            account: {},
            stats: null,
            statsLoading: true,
        }
    }

    componentDidMount = async () => {
        const user = await TokenService.getUser()
        this.setState({ account: user ? user.account : {} })
        try {
            const stats = await AdminService.getGlobalStats()
            this.setState({ stats, statsLoading: false })
        } catch (e) {
            this.setState({ statsLoading: false })
        }
    }

    logOut = () => {
        TokenService.removeUser()
        window.location.href = '/admin/login'
    }

    render() {
        const menuItems = [
            { title: 'Buds', icon: FaGamepad, path: '/admin/buds', color: 'from-purple-500 to-pink-500' },
            { title: 'Packs / Boosters', icon: FaGift, path: '/admin/packs', color: 'from-fuchsia-500 to-purple-600' },
            { title: 'Leagues', icon: FaChartLine, path: '/admin/leagues', color: 'from-blue-500 to-cyan-500' },
            { title: 'Players', icon: FaUsers, path: '/admin/players', color: 'from-green-500 to-emerald-500' },
            { title: 'Business', icon: FaStore, path: '/admin/business', color: 'from-orange-500 to-red-500' },
            { title: 'Statistics', icon: FaChartBar, path: '/admin/stats', color: 'from-indigo-500 to-purple-500' },
            { title: 'Admin Accounts', icon: FaUserShield, path: '/admin/accounts', color: 'from-slate-600 to-slate-800' },
            { title: 'Bots', icon: FaRobot, path: '/admin/bots', color: 'from-teal-500 to-cyan-600' },
            { title: 'Subscribers', icon: FaBell, path: '/admin/subscribers', color: 'from-pink-500 to-rose-500' },
            { title: 'Trackers', icon: FaChartLine, path: '/admin/trackers', color: 'from-amber-500 to-orange-500' },
            { title: 'Tips', icon: FaLightbulb, path: '/admin/tips', color: 'from-yellow-400 to-amber-500' },
            { title: 'News', icon: FaNewspaper, path: '/admin/news', color: 'from-cyan-500 to-blue-600' },
            { title: 'Settings', icon: FaCog, path: '/admin/settings', color: 'from-gray-600 to-slate-700' },
        ];

        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
                {/* Header */}
                <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
                    <div className="max-w-7xl mx-auto px-6 py-4">
                        <div className="flex items-center justify-between">
                            <h1 className="text-2xl font-bold text-gray-900">Administration</h1>
                            <button 
                                onClick={this.logOut}
                                className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200 font-medium shadow-sm hover:shadow-md"
                            >
                                <FaSignOutAlt />
                                Log out
                            </button>
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="max-w-7xl mx-auto px-6 py-8">
                    {/* Welcome Card */}
                    {this.state.account && (
                        <div className="bg-white rounded-2xl shadow-md p-6 mb-8">
                            <h2 className="text-xl font-semibold text-gray-800">
                                Welcome back, {this.state.account.firstname} {this.state.account.lastname}
                            </h2>
                            <p className="text-gray-600 mt-1">Select a section to manage</p>
                        </div>
                    )}

                    {/* Global Stats */}
                    {this.state.statsLoading ? (
                        <div className="bg-white rounded-2xl shadow-md p-6 mb-8">
                            <p className="text-gray-500 text-sm">Loading stats...</p>
                        </div>
                    ) : this.state.stats && (
                        <div className="mb-8">
                            <h2 className="text-lg font-semibold text-gray-700 mb-4">App Overview</h2>
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
                                {/* Players */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center col-span-1">
                                    <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaUsers className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.player?.nb_players || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Players</p>
                                </div>
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center mb-2">
                                        <FaUserCheck className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.player?.nb_online || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Online</p>
                                </div>
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaUserSlash className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.player?.nb_deactivated || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Deactivated</p>
                                </div>
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaTrashAlt className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.player?.nb_deleted || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Deleted</p>
                                </div>
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-pink-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaBell className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.player?.active_notification || 0).toLocaleString()}%</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Notifications enabled</p>
                                </div>
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center mb-2">
                                        <FaApple className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.app?.nb_ios || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">iOS</p>
                                </div>
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-lime-600 rounded-lg flex items-center justify-center mb-2">
                                        <FaAndroid className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.app?.nb_android || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Android</p>
                                </div>
                                {/* Safes */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaShieldAlt className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.player?.nb_safes || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Safes</p>
                                </div>
                                {/* Distance */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gradient-to-br from-lime-500 to-green-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaRunning className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.player?.distance_covered || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Km covered</p>
                                </div>
                                {/* Games */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaGamepad className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.game?.nb_games || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Games</p>
                                </div>
                                {/* Cards */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaBoxOpen className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.game?.nb_cards || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Cards</p>
                                </div>
                                {/* Businesses */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaStore className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.business?.nb_businesses || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Businesses</p>
                                </div>
                                {/* Distributions */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaShareAlt className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.business?.nb_distributions || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Distributions</p>
                                </div>
                                {/* Views */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col items-center text-center">
                                    <div className="w-10 h-10 bg-gradient-to-br from-sky-500 to-blue-500 rounded-lg flex items-center justify-center mb-2">
                                        <FaEye className="text-white text-lg" />
                                    </div>
                                    <p className="text-2xl font-bold text-gray-900">{(this.state.stats.business?.nb_views || 0).toLocaleString()}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">Business Views</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Menu Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {menuItems.map((item, index) => {
                            const Icon = item.icon;
                            return (
                                <div
                                    key={index}
                                    onClick={() => window.location.href = item.path}
                                    className="group relative bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden"
                                >
                                    <div className="p-6">
                                        <div className={`inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br ${item.color} rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300`}>
                                            <Icon className="text-2xl text-white" />
                                        </div>
                                        <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                                            {item.title}
                                        </h3>
                                    </div>
                                    <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${item.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(AdminHome)